<template>
  <div class="salesmandailiPage">
     <XR-head titleText="我的辖区代理" :rightShow="false" ref="headObj"></XR-head>
    <div class="total balance"  :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
        <p class="title">总人数(人)</p>
        <p class="money">{{totalData.gltotal}}</p>
    </div>
    <mu-list>
        <router-link to="/salesman/mydaililist?userbs=4" class="proList" v-if="totalData.userbs ==6 || totalData.userbs ==7|| totalData.userbs ==8">
        <mu-list-item :title="saleMenCategory?saleMenCategory[4]:'社区服务商'">
            <mu-icon style="font-size:22px;" slot="left" value=":fa fa-myshequ"/>
            <p>{{totalData.glsqtotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
        </mu-list-item>
        </router-link>
        <router-link to="/salesman/mydaililist?userbs=6" class="proList" v-if="totalData.userbs ==7|| totalData.userbs ==8">
        <mu-list-item :title="saleMenCategory?saleMenCategory[6]:'县区管理中心'">
            <mu-icon style="font-size:20px;" slot="left" value=":fa fa-myxianqu"/>
            <p>{{totalData.glxqtotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
        </mu-list-item>
        </router-link>
        <router-link to="/salesman/mydaililist?userbs=7" class="proList" v-if="totalData.userbs ==8">
        <mu-list-item :title="saleMenCategory?saleMenCategory[7]:'市级运营中心'">
            <mu-icon style="font-size:20px;" slot="left" value=":fa fa-myxianqu"/>
            <p>{{totalData.glsjtotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
        </mu-list-item>
        </router-link>
    </mu-list>
    </div>
</template>
<script>
export default {
    data(){
        return {
            totalData:{
            },
            
            siteConfig:{
                
            },
			
			saleMenCategory:window.localStorage.saleMenCategory.split(",")
        }
    },
    mounted(){
        this.getSiteInfo()
        this.getList()
    },
    methods:{
           
        getList(){            
            var ths = this;  
            
            ths.$post(
                "/Salesman/SalesmanServer/GetMyXiaQuCount", this.searchInfo
            ).then(function(res) {
                if(!res.IsSuccess){

                }else{
                    ths.totalData = res.Data
                }
            });
        },  
        getSiteInfo: function () {    
            const ths = this;
            this.$post('/Shop/SiteConfigServer/GetSiteConfig')
                .then(function (res) {
                if(res.IsSuccess){
                    ths.siteConfig = res.Data
                }         
            })
            .catch(function (err) {
                console.log(err)
            })    
        },         
    }
}
</script>

<style>
      body .salesmandailiPage{
        background: #fff;
      }
      .salesmandailiPage .total {
          padding: 20px;
          overflow: hidden;
          background: url("/static/us-top-bg.png");
          background-size: 100% 100%;
      }
      .salesmandailiPage .title {
          line-height: 24px;
          font-size: 14px;
          color: #fff;
      }
      .salesmandailiPage .show-right .mu-item-content{
          display: flex;
      }
      .salesmandailiPage .show-right .mu-item-title-row{
        width: 100%;
      }
      .salesmandailiPage .text{
        color: #666666;
      }
      .salesmandailiPage .money {
          font-size: 46px;
          color: red;
          line-height: 42px;
          padding: 10px 0;
          letter-spacing: -1px;
          color: #fff;
      }
      .salesmandailiPage .mu-appbar .mu-appbar-title{
        font-size: 16px;
      }
      .salesmandailiPage h5
        {
            font-size:16px;
            text-align:center;  
            font-weight:400;  
            padding:17px 0;
        }
      .salesmandailiPage .mu-item.show-right{
        padding-left: 50px;
      }
      .salesmandailiPage .mu-list .proList .mu-item-wrapper{
        border-bottom: 1px solid #f5f5f5;
      }
      .salesmandailiPage .mu-icon{
        margin-bottom: 5px;
      }
</style>




// WEBPACK FOOTER //
// src/pages/salesman/mydaili.vue